import React, { useState } from "react";
import { useHistory, Link } from "react-router-dom";
// import { AuthContext } from "../context/AuthContext";
import firebase from "firebase/app";
import Alert from "./Alert";
import createUser from "../requests/createUser";

const Register = () => {
  const history = useHistory();
  // const { user, setUser } = useContext(AuthContext);

  const initialState = {
    fields: {
      firstname: "",
      lastname: "",
      email: "",
      password: "",
      passwordRepeat: "",
    },
    alert: {
      message: "",
      isSuccess: false,
    }
  };
  const [fields, setFields] = useState(initialState.fields);
  const [alert, setAlert] = useState(initialState.alert);
  // const [user, setUser] = useState(null);

  const handleFieldChange = (event) => {
    setFields((prev) => {
      return {
        ...prev,
        [event.target.name]: event.target.value,
      };
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (fields.password === fields.passwordRepeat) {
      firebase.auth().createUserWithEmailAndPassword(fields.email, fields.password)
      .then((userCredential) => {
        // Signed in 
        console.log(userCredential.user);
        // setUser(userCredential.user);
      })
      .then(() => {
        const newUser = firebase.auth().currentUser;
        newUser.sendEmailVerification({
          url: "https://merchsheet.netlify.app"
        })
        .then(() => {
          console.log("Verification email sent");
        })
        .catch(e => console.log(e));
      })
      .then(() => {
        const currentUser = firebase.auth().currentUser;
        currentUser.getIdToken().then(token => {
          createUser(token, {
            firstname: fields.firstname,
            lastname: fields.lastname,
            email: fields.email,
            _id: firebase.auth().currentUser.uid,
          })        
          .then(response => {
            if (response.status === 201) {
              firebase.auth().signOut().then(() => {
                // setUser(null);
                history.push("/");
              });
            } else {
              setAlert({
                message: "A server error occurred. Please try again.",
              });
              const failedReg = firebase.auth().currentUser;
              failedReg.delete();
            }
          })
        })
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorCode, errorMessage);
        setAlert({
          message: "A server error occurred. Please try again.",
        });
      });
    } else {
      setAlert({
        message: "The two passwords didn't match. Please try again."
      })
    }
  };

  return (
    <div className="container">
      <section>
        <article>
          
          <p>
            The merchsheet app is only open to registered users.
            Fill in the basic details below to set up your account.
          </p>
          <br />
          <div className="account-verification-instructions">
            <h4>Email verification</h4><br />
            <p>After clicking Sign Up you will receive an email from
            the merchsheet-app team which contains a verification link.</p>
            <br />
            <p>You will need to click that link to complete registration.</p>
          </div>
          
          <form onSubmit={handleSubmit} className="register-form" action="" method="post">
            <h2 className="heading">Create an account</h2>
            <Alert message={alert.message} />
            <div>
              <label htmlFor="firstname">First name</label>
              <input
                type="firstname"
                name="firstname"
                id="firstname"
                value={fields.firstname}
                onChange={handleFieldChange}
              />
            </div>

            <div>
              <label htmlFor="lastname">Last name</label>
              <input
                type="lastname"
                name="lastname"
                id="lastname"
                value={fields.lastname}
                onChange={handleFieldChange}
              />
            </div>
            
            <div>
              <label htmlFor="email">Email address</label>
              <input
                type="email"
                name="email"
                id="email"
                value={fields.email}
                onChange={handleFieldChange}
              />
            </div>
            
            <div>
              <label htmlFor="password">Password</label>
              <input
                type="password"
                name="password"
                id="password"
                value={fields.password}
                onChange={handleFieldChange}
              />
            </div>
            
            <div>
              <label htmlFor="passwordRepeat">Repeat password</label>
              <input
                type="password"
                name="passwordRepeat"
                id="passwordRepeat"
                value={fields.passwordRepeat}
                onChange={handleFieldChange}
              />
            </div>
            
            <div>
              <button type="submit" className="form-button">
                Sign Up
              </button>
            </div>

            <div className="account-already">
              <p>
                Already have an account?
                <Link to="/login" className="button-link">Sign in</Link>
              </p>
            </div>
            
          </form>
        </article>
      
      </section>
    </div>
  )
}

export default Register;